import { isNullOrUndefined } from '@coveo/bueno';
import { configuration } from '../../app/common-reducers.js';
import { facetOrderReducer as facetOrder } from '../../features/facets/facet-order/facet-order-slice.js';
import { back, forward } from '../../features/history/history-actions.js';
import { logNavigateBackward, logNavigateForward, logNoResultsBack, } from '../../features/history/history-analytics-actions.js';
import { history } from '../../features/history/history-slice.js';
import { executeSearch } from '../../features/search/search-actions.js';
import { loadReducerError } from '../../utils/errors.js';
import { buildController, } from '../controller/headless-controller.js';
/**
 * Creates a `HistoryManager` controller instance.
 *
 * @param engine - The headless engine.
 * @returns A `HistoryManager` controller instance.
 *
 * @group Controllers
 * @category HistoryManager
 */
export function buildHistoryManager(engine) {
    if (!loadHistoryManagerReducers(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const { dispatch } = engine;
    const getState = () => engine.state;
    const canGoBack = (state) => {
        return state.past.length > 0 && !isNullOrUndefined(state.present);
    };
    return {
        ...controller,
        // TODO: https://coveord.atlassian.net/browse/KIT-2969:
        // Should be able to get rid of this local optimization following history management change
        subscribe(listener) {
            listener();
            let previous = JSON.stringify(getState().history.present);
            const strictListener = () => {
                const current = JSON.stringify(getState().history.present);
                const hasChanged = previous !== current;
                if (hasChanged) {
                    previous = current;
                    listener();
                }
            };
            return engine.subscribe(() => strictListener());
        },
        get state() {
            return getState().history;
        },
        async back() {
            if (!canGoBack(this.state)) {
                return;
            }
            await dispatch(back());
            dispatch(executeSearch({
                legacy: logNavigateBackward(),
            }));
        },
        async forward() {
            if (!this.state.future.length || !this.state.present) {
                return;
            }
            await dispatch(forward());
            dispatch(executeSearch({
                legacy: logNavigateForward(),
            }));
        },
        async backOnNoResults() {
            if (!canGoBack(this.state)) {
                return;
            }
            await dispatch(back());
            dispatch(executeSearch({
                legacy: logNoResultsBack(),
            }));
        },
    };
}
function loadHistoryManagerReducers(engine) {
    engine.addReducers({ history, configuration, facetOrder });
    return true;
}
